

// // Updated Frontend: BlogManagement.js
// import React, { useState } from 'react';
// import axios from 'axios';
// import './BlogManagement.css';

// const API_URL = 'https://apitop.topranohotelandlounge.com'; // Use environment variable in production

// const BlogManagement = ({ blogs, onUpdate }) => {
//   const [formData, setFormData] = useState({
//     title: '',
//     fullContent: '',
//     author: '',
//     image: '',
//     category: '',
//   });
//   const [editingBlog, setEditingBlog] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null); // For success/error alerts
//   const [error, setError] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);
//     setError(null);
//     try {
//       if (editingBlog) {
//         await axios.put(`${API_URL}/api/blogs/${editingBlog.id}`, formData);
//         setMessage('Blog updated successfully!');
//       } else {
//         await axios.post(`${API_URL}/api/blogs`, formData);
//         setMessage('Blog created successfully!');
//       }
//       setFormData({ title: '', fullContent: '', author: '', image: '', category: '' });
//       setEditingBlog(null);
//       onUpdate();
//     } catch (err) {
//       console.error('Error saving blog:', err);
//       setError(err.response?.data?.message || 'Failed to save blog. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (blog) => {
//     setFormData({
//       title: blog.title,
//       fullContent: blog.fullContent || '',
//       author: blog.author,
//       image: blog.image || '',
//       category: blog.category || '',
//     });
//     setEditingBlog(blog);
//     setMessage(null);
//     setError(null);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this blog?')) return;
//     setMessage(null);
//     setError(null);
//     try {
//       await axios.delete(`${API_URL}/api/blogs/${id}`);
//       setMessage('Blog deleted successfully!');
//       onUpdate();
//     } catch (err) {
//       console.error('Error deleting blog:', err);
//       setError(err.response?.data?.message || 'Failed to delete blog. Please try again.');
//     }
//   };

//   return (
//     <div className="blog-management">
//       {message && <div className="alert alert-success">{message}</div>}
//       {error && <div className="alert alert-error">{error}</div>}
//       <div className="admin-form">
//         <h2 className="form-title">
//           {editingBlog ? 'Edit Blog' : 'Create New Blog'}
//         </h2>
//         <form onSubmit={handleSubmit} className="form-container">
//           <div className="form-grid">
//             <input
//               type="text"
//               placeholder="Title"
//               value={formData.title}
//               onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//               className="form-input"
//               required
//             />
//             <input
//               type="text"
//               placeholder="Author"
//               value={formData.author}
//               onChange={(e) => setFormData({ ...formData, author: e.target.value })}
//               className="form-input"
//               required
//             />
//           </div>
//           <textarea
//             placeholder="Content"
//             value={formData.fullContent}
//             onChange={(e) => setFormData({ ...formData, fullContent: e.target.value })}
//             className="form-textarea"
//             required
//           />
//           <div className="form-grid">
//             <input
//               type="url"
//               placeholder="Image URL (optional)"
//               value={formData.image}
//               onChange={(e) => setFormData({ ...formData, image: e.target.value })}
//               className="form-input"
//             />
//             <input
//               type="text"
//               placeholder="Category (optional)"
//               value={formData.category}
//               onChange={(e) => setFormData({ ...formData, category: e.target.value })}
//               className="form-input"
//             />
//           </div>
//           <div className="form-buttons">
//             <button
//               type="submit"
//               disabled={loading}
//               className="btn btn-primary"
//             >
//               {loading ? 'Saving...' : editingBlog ? 'Update Blog' : 'Create Blog'}
//             </button>
//             {editingBlog && (
//               <button
//                 type="button"
//                 onClick={() => {
//                   setFormData({ title: '', fullContent: '', author: '', image: '', category: '' });
//                   setEditingBlog(null);
//                 }}
//                 className="btn btn-secondary"
//               >
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </div>
//       <div className="list-container">
//         <h2 className="list-title">All Blogs ({blogs.length})</h2>
//         {blogs.map((blog) => (
//           <div key={blog._id} className="list-item">
//             <div className="list-item-header">
//               <h3 className="list-item-title">{blog.title}</h3>
//               <div className="list-item-actions">
//                 <button
//                   onClick={() => handleEdit(blog)}
//                   className="btn btn-primary"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDelete(blog.id)} // Use blog.id (slug)
//                   className="btn btn-danger"
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//             <p className="list-item-content">
//               {(blog.fullContent || '').substring(0, 150)}...
//             </p>
//             <div className="list-item-meta">
//               <span>By {blog.author}</span>
//               {blog.category && (
//                 <span className="badge badge-secondary">{blog.category}</span>
//               )}
//             </div>
//             {blog.image && <img src={blog.image} alt={blog.title} className="list-item-image" />}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default BlogManagement;


// Updated Frontend: BlogManagement.js
import React, { useState } from 'react';
import axios from 'axios';
import './BlogManagement.css';

const API_URL = 'https://apitop.topranohotelandlounge.com'; // Use environment variable in production

const BlogManagement = ({ blogs, onUpdate }) => {
  const [formData, setFormData] = useState({
    title: '',
    fullContent: '',
    author: '',
    image: '',
    category: '',
  });
  const [editingBlog, setEditingBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null); // For success/error alerts
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);
    try {
      if (editingBlog) {
        await axios.put(`${API_URL}/api/blogs/${editingBlog.id}`, formData);
        setMessage('Blog updated successfully!');
      } else {
        await axios.post(`${API_URL}/api/blogs`, formData);
        setMessage('Blog created successfully!');
      }
      setFormData({ title: '', fullContent: '', author: '', image: '', category: '' });
      setEditingBlog(null);
      onUpdate();
    } catch (err) {
      console.error('Error saving blog:', err);
      setError(err.response?.data?.message || 'Failed to save blog. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (blog) => {
    setFormData({
      title: blog.title,
      fullContent: blog.fullContent || '',
      author: blog.author,
      image: blog.image || '',
      category: blog.category || '',
    });
    setEditingBlog(blog);
    setMessage(null);
    setError(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this blog?')) return;
    setMessage(null);
    setError(null);
    try {
      await axios.delete(`${API_URL}/api/blogs/${id}`);
      setMessage('Blog deleted successfully!');
      onUpdate();
    } catch (err) {
      console.error('Error deleting blog:', err);
      setError(err.response?.data?.message || 'Failed to delete blog. Please try again.');
    }
  };

  return (
    <div className="blog-management">
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-error">{error}</div>}
      <div className="admin-form">
        <h2 className="form-title">
          {editingBlog ? 'Edit Blog' : 'Create New Blog'}
        </h2>
        <form onSubmit={handleSubmit} className="form-container">
          <div className="form-grid">
            <div className="form-field">
              <label htmlFor="title" className="form-label">Title</label>
              <input
                id="title"
                type="text"
                placeholder="Enter blog title"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                className="form-input"
                required
              />
            </div>
            <div className="form-field">
              <label htmlFor="author" className="form-label">Author</label>
              <input
                id="author"
                type="text"
                placeholder="Enter author name"
                value={formData.author}
                onChange={(e) => setFormData({ ...formData, author: e.target.value })}
                className="form-input"
                required
              />
            </div>
          </div>
          
          <div className="form-field">
            <label htmlFor="content" className="form-label">Content</label>
            <textarea
              id="content"
              placeholder="Write your blog content here..."
              value={formData.fullContent}
              onChange={(e) => setFormData({ ...formData, fullContent: e.target.value })}
              className="form-textarea"
              required
            />
          </div>
          
          <div className="form-grid">
            <div className="form-field">
              <label htmlFor="image" className="form-label">Image URL (optional)</label>
              <input
                id="image"
                type="url"
                placeholder="https://example.com/image.jpg"
                value={formData.image}
                onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                className="form-input"
              />
            </div>
            <div className="form-field">
              <label htmlFor="category" className="form-label">Category (optional)</label>
              <input
                id="category"
                type="text"
                placeholder="e.g., Technology, Travel"
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                className="form-input"
              />
            </div>
          </div>
          
          <div className="form-buttons">
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
            >
              {loading ? 'Saving...' : editingBlog ? 'Update Blog' : 'Create Blog'}
            </button>
            {editingBlog && (
              <button
                type="button"
                onClick={() => {
                  setFormData({ title: '', fullContent: '', author: '', image: '', category: '' });
                  setEditingBlog(null);
                }}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
      
      <div className="list-container">
        <h2 className="list-title">All Blogs ({blogs.length})</h2>
        {blogs.length === 0 ? (
          <div className="empty-state">
            <p>No blogs yet. Create your first blog above!</p>
          </div>
        ) : (
          blogs.map((blog) => (
            <div key={blog._id} className="list-item">
              <div className="list-item-header">
                <h3 className="list-item-title">{blog.title}</h3>
                <div className="list-item-actions">
                  <button
                    onClick={() => handleEdit(blog)}
                    className="btn btn-primary"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(blog.id)} // Use blog.id (slug)
                    className="btn btn-danger"
                  >
                    Delete
                  </button>
                </div>
              </div>
              <p className="list-item-content">
                {(blog.fullContent || '').substring(0, 150)}...
              </p>
              <div className="list-item-meta">
                <span>By {blog.author}</span>
                {blog.category && (
                  <span className="badge badge-secondary">{blog.category}</span>
                )}
              </div>
              {blog.image && <img src={blog.image} alt={blog.title} className="list-item-image" />}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BlogManagement;